import { defineComponent as s, openBlock as t, createElementBlock as H, mergeProps as m, unref as V, renderSlot as d, createElementVNode as o, createCommentVNode as h } from "vue";
import { useScalarIcon as p } from "../hooks/useScalarIcon.js";
const i = { key: 0 }, u = { key: 1 }, A = { key: 2 }, M = { key: 3 }, g = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconElevator"
}, y = /* @__PURE__ */ s({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const n = l, { bind: Z, weight: e } = p(n);
    return (r, a) => (t(), H("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, V(Z)), [
      d(r.$slots, "default"),
      V(e) === "bold" ? (t(), H("g", i, a[0] || (a[0] = [
        o("path", { d: "M208,28H48A20,20,0,0,0,28,48V208a20,20,0,0,0,20,20H208a20,20,0,0,0,20-20V48A20,20,0,0,0,208,28ZM164,128v76H140V128Zm-48,76H92V128h24Zm88,0H188V116a12,12,0,0,0-12-12H80a12,12,0,0,0-12,12v88H52V52H204ZM100,76a12,12,0,0,1,12-12h32a12,12,0,0,1,0,24H112A12,12,0,0,1,100,76Z" }, null, -1)
      ]))) : V(e) === "duotone" ? (t(), H("g", u, a[1] || (a[1] = [
        o("path", {
          d: "M184,104V216H72V104Z",
          opacity: "0.2"
        }, null, -1),
        o("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-32,80v96H136V112Zm-56,96H80V112h40Zm88,0H192V104a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V208H48V48H208V208ZM152,72a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,72Z" }, null, -1)
      ]))) : V(e) === "fill" ? (t(), H("g", A, a[2] || (a[2] = [
        o("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM112,56h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16Zm8,152H64V96h56Zm72,0H136V96h56Z" }, null, -1)
      ]))) : V(e) === "light" ? (t(), H("g", M, a[3] || (a[3] = [
        o("path", { d: "M208,34H48A14,14,0,0,0,34,48V208a14,14,0,0,0,14,14H208a14,14,0,0,0,14-14V48A14,14,0,0,0,208,34Zm-30,76V210H134V110ZM122,210H78V110h44Zm88-2a2,2,0,0,1-2,2H190V104a6,6,0,0,0-6-6H72a6,6,0,0,0-6,6V210H48a2,2,0,0,1-2-2V48a2,2,0,0,1,2-2H208a2,2,0,0,1,2,2ZM150,72a6,6,0,0,1-6,6H112a6,6,0,0,1,0-12h32A6,6,0,0,1,150,72Z" }, null, -1)
      ]))) : V(e) === "regular" ? (t(), H("g", g, a[4] || (a[4] = [
        o("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-32,80v96H136V112Zm-56,96H80V112h40Zm88,0H192V104a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V208H48V48H208V208ZM152,72a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,72Z" }, null, -1)
      ]))) : V(e) === "thin" ? (t(), H("g", f, a[5] || (a[5] = [
        o("path", { d: "M208,36H48A12,12,0,0,0,36,48V208a12,12,0,0,0,12,12H208a12,12,0,0,0,12-12V48A12,12,0,0,0,208,36Zm-28,72V212H132V108ZM124,212H76V108h48Zm88-4a4,4,0,0,1-4,4H188V104a4,4,0,0,0-4-4H72a4,4,0,0,0-4,4V212H48a4,4,0,0,1-4-4V48a4,4,0,0,1,4-4H208a4,4,0,0,1,4,4ZM148,72a4,4,0,0,1-4,4H112a4,4,0,0,1,0-8h32A4,4,0,0,1,148,72Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  y as default
};
